<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  components: {
    conditionPart,
  },
  computed: {
    hasUberEats() {
      return window.localStorage["hasUberEats"] == "true";
    },
    columns() {
      if (this.reportType == "detail") {
        let s = [
          {
            name: "TerminalNumber",
          },
          {
            name: "TerminalName",
          },
          {
            name: "BusinessDay",
          },
          {
            name: "SalNumber",
          },
          {
            name: "Total",
          },
          {
            name: "Cash",
          },
          {
            name: "CreditCardPrice",
          },
          {
            name: "PayType1",
          },
          {
            name: "PayType2",
          },
          {
            name: "CouponPrice",
          },
          {
            name: "EasyCardPrice",
          },
          {
            name: "LinePayPrice",
          },
          {
            name: "PXPayPrice",
          },
          {
            name: "Deposit",
          },
        ];
        if (this.hasUberEats) {
          s.push({ name: "UberEatsPrice" });
        }
        return s;
      } else {
        let s = [
          {
            name: "TerminalNumber",
          },
          {
            name: "TerminalName",
          },
          {
            name: "BusinessDay",
          },
          {
            name: "Total",
          },
          {
            name: "Cash",
          },
          {
            name: "CreditCardPrice",
          },
          {
            name: "PayType1",
          },
          {
            name: "PayType2",
          },
          {
            name: "CouponPrice",
          },
          {
            name: "EasyCardPrice",
          },
          {
            name: "LinePayPrice",
          },
          {
            name: "PXPayPrice",
          },
          {
            name: "Deposit",
          },
        ];
        if (this.hasUberEats) {
          s.push({ name: "UberEatsPrice" });
        }
        return s;
      }
    },
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getPay(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getPay(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printPay(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getPay(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
